export const getRatingColor = (rating: number) => {
  if (rating > 7) {
    return "#3bb33b";
  } else if (rating > 5) {
    return "grey.400";
  } else {
    return "red";
  }
};
